<main class="form-panel">
  <router-outlet></router-outlet>

  <div class="languages-switch">
    <app-language-switch></app-language-switch>
  </div>

  <div class="legal-links owners-theme-hide">
    <a href="//www.tokeet.com/terms.html" target="_blank" rel="noopener">{{ 'button.label.terms' | translate }}</a> |
    <a href="//www.tokeet.com/privacy.html" target="_blank" rel="noopener">{{ 'form.label.privacyPolicy' | translate }}</a>
  </div>

</main>

<div class="intro-panel">
  <div class="tokeet-theme-only">
    <div class="intro-text text-header" [innerHTML]="'app.tokeet.title' | translate">
    </div>
    <div class="intro-text" [innerHTML]="'app.tokeet.description' | translate">
    </div>
  </div>
  <div class="checklist-theme-only">
    <div class="intro-text text-header">
      {{ 'app.checklist.title' | translate }}
    </div>
    <div class="intro-text">
      <header>{{ 'app.title.features' | translate }}</header>
      <ul>
        <li>{{ 'app.checklist.feature1' | translate }}</li>
        <li>{{ 'app.checklist.feature2' | translate }} </li>
        <li>{{ 'app.checklist.feature3' | translate }} </li>
        <li>{{ 'app.checklist.feature4' | translate }} </li>
        <li>{{ 'app.checklist.feature5' | translate }} </li>
      </ul>
    </div>
  </div>
  <div class="owners-theme-only">
    <div class="intro-text text-header">
      {{ 'app.owners.title' | translate }}
    </div>
    <div class="app-features"
         *ngIf="rategenieFeatureImageIndex$ | async as imageIndex">
      <h3 class="app-features-header">{{'app.title.features' | translate}}</h3>
      <ul class="app-features-list">
        <li [class.active]="imageIndex === 1">
          {{ 'app.owners.feature1' | translate }}
        </li>
        <li [class.active]="imageIndex === 2">
          {{ 'app.owners.feature2' | translate }}
        </li>
        <li [class.active]="imageIndex === 3">
          {{ 'app.owners.feature3' | translate }}
        </li>
        <li [class.active]="imageIndex === 4">
          {{ 'app.owners.feature4' | translate }}
        </li>
        <li [class.active]="imageIndex === 5">
          {{ 'app.owners.feature5' | translate }}
        </li>
        <li [class.active]="imageIndex === 6">
          {{ 'app.owners.feature6' | translate }}
        </li>
      </ul>
      <div class="app-feature-image-wrapper"
           *ngIf="ownersFeatureImageIndex$ | async as imageIndex">
        <img [src]="'assets/apps/owners/'+imageIndex+'.png'"
             class="app-feature-image" />
      </div>
    </div>
  </div>
  <div class="webready-theme-only">
    <div class="intro-text text-header">
      {{ 'app.webready.title' | translate }}
    </div>
    <div class="intro-text">
      <header>{{ 'app.title.features' | translate }}</header>
      <ul>
        <li>{{ 'app.webready.feature1' | translate }}</li>
        <li>{{ 'app.webready.feature2' | translate }}</li>
        <li>{{ 'app.webready.feature3' | translate }}</li>
        <li>{{ 'app.webready.feature4' | translate }}</li>
        <li>{{ 'app.webready.feature5' | translate }}</li>
      </ul>
      <div class="app-feature-image-wrapper" *ngIf="webreadyFeatureImageIndex$ | async as imageIndex">
        <img [src]="'assets/apps/webready/'+imageIndex+'.png'" class="app-feature-image" />
      </div>
    </div>
  </div>
  <div class="sympl-theme-only">
    <div class="intro-text text-header">
      {{ 'app.sympl.title' | translate }}
    </div>
    <div class="intro-text" [innerHTML]="'app.sympl.description' | translate">
    </div>
  </div>
  <div class="rategenie-theme-only">
    <div class="intro-text text-header">
      {{ 'app.rategenie.title' | translate }}
    </div>
    <div class="app-features" *ngIf="rategenieFeatureImageIndex$ | async as imageIndex">
      <h3 class="app-features-header">{{'app.title.features' | translate}}</h3>
        <ul class="app-features-list">
          <li [class.active]="imageIndex === 1">
            {{ 'app.rategenie.feature1' | translate }}
          </li>
          <li [class.active]="imageIndex === 2">
            {{ 'app.rategenie.feature2' | translate }}
          </li>
          <li [class.active]="imageIndex === 3">
            {{ 'app.rategenie.feature3' | translate }}
          </li>
          <li [class.active]="imageIndex === 4">
            {{ 'app.rategenie.feature4' | translate }}
          </li>
          <li [class.active]="imageIndex === 5">
            {{ 'app.rategenie.feature5' | translate }}
          </li>
          <li [class.active]="imageIndex === 6">
            {{ 'app.rategenie.feature6' | translate }}
          </li>
          <li [class.active]="imageIndex === 7">
            {{ 'app.rategenie.feature7' | translate }}
          </li>
        </ul>
        <div class="app-feature-image-wrapper">
          <img *ngIf="imageIndex === 1" src="assets/apps/rategenie/1.png" alt="" style="max-height: 250px;">
          <img *ngIf="imageIndex === 2" src="assets/apps/rategenie/2.png" alt="" style="max-height: 250px;">
          <img *ngIf="imageIndex === 3" src="assets/apps/rategenie/3.png" alt="" style="max-height: 250px;">
          <img *ngIf="imageIndex === 4" src="assets/apps/rategenie/4.png" alt="" style="max-height: 300px;">
          <img *ngIf="imageIndex === 5" src="assets/apps/rategenie/5.png" alt="" style="max-height: 250px;">
          <img *ngIf="imageIndex === 6" src="assets/apps/rategenie/6.png" alt="" style="max-height: 250px;">
          <img *ngIf="imageIndex === 7" src="assets/apps/rategenie/7.png" alt="" style="max-height: 200px;">
        </div>
    </div>
  </div>
  <div class="signature-theme-only">
    <div class="intro-text text-header">
      {{ 'app.signature.title' | translate }}
    </div>
    <div class="intro-text">
      {{ 'app.signature.description' | translate }}
      <header class="logos-header">{{ 'app.signature.title2' | translate }}</header>
    </div>
  </div>

  <div class="apps-logos webready-theme-hide rategenie-theme-hide owners-theme-hide">
    <a href="//www.tokeet.com"       rel="noopener" style="background-image: url(/assets/logos/tokeet.svg)" title="Tokeet"></a>
    <a href="//www.usesignature.com" rel="noopener" style="background-image: url(/assets/logos/signature.svg)" title="Signature"></a>
    <a href="//useautomata.com"  rel="noopener" style="background-image: url(/assets/logos/automata.svg)" title="Automata"></a>
    <a href="//rategenie.io"     rel="noopener" style="background-image: url(/assets/logos/rategenie.svg)" title="Rategenie"></a>
    <a href="//www.tokeet.com/owner-manager.html"  rel="noopener" style="background-image: url(/assets/logos/owners.svg)" title="Owners"></a>
    <a href="//www.tokeet.com/reports.html"   rel="noopener" style="background-image: url(/assets/logos/margins.svg)" title="Margins"></a>
    <a href="//usechecklist.com" rel="noopener" style="background-image: url(/assets/logos/checklist.svg)" title="Checklist"></a>
    <a href="//usewebready.com"  rel="noopener" style="background-image: url(/assets/logos/webready.svg)" title="Webready"></a>
    <a class="checklist-theme-only webready-theme-only sympl-theme-only" href="//sympl.cm"         rel="noopener" style="background-image: url(/assets/logos/sympl.png)" title="Sympl"></a>
  </div>
</div>
